import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import OnlinePayment from "../../../../common/credit-card/online-payment.component.jsx";
import EventBus from "../../../../common/EventBus.js";
import MoneyInputForm from "../../../../common/form/moneyinput.component.jsx";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import LoadingSpinner from "../../../../common/spinner/loading.component.jsx";
import InvoiceStatusBadge from "../../../../invoice/status.component.jsx";
import TestModeAlert from "../../../../payment-processing/components/TestModeAlert";
import { ExternalCheckoutPaymentTypesMapping, ExternalPaymentTypesMapping } from "../../../../payment/externalpaymenttypesmapping.jsx";
import OnlinePaymentReceiptSection from "../../../../payment/onlinepaymentreceiptsection.component.tsx";
import NumberHelper from '../../../../state/helpers/NumberHelper';
import { PAYMENT_SOURCE, PAYMENT_STATUS, PAYMENT_TYPE } from '../../../../state/helpers/Payment';
import { INTEGRATION_KEY } from "../../../../state/integration/Constants";
import { PROPOSAL_TYPE } from "../../../../state/proposal/ProposalType";
import SectionWrapper from "../../sectionwrapper.component.jsx";

const messages = defineMessages({
    payment_note: {
        id: 'payment.payment_note',
        defaultMessage: 'Online payment',
    },
})
class PaymentContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            isDummy: this.props.isDummy === true,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            isPdf: this.props.isPdf || false,
            autoOpen: this.props.autoOpen || false,
            included: this.props.included || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
            loading: false,
            payMode: false,
            creditCardError: '',
            publicKey: '',
            partialPaymentAmount: '0',
            showEditPaymentAmount: false,
            activeTab: 'credit-card',
            paymentMethods: [],
            acceptedCardBrands: this.props.section?.attributes?.content?.acceptedCardBrands || [],
            paymentInProgress: false,
            submitDisabled: false,
            hideAcceptButton: this.props.hideAcceptButton || false,
            onVariablesUpdate: this.props.onVariablesUpdate || function () { },
        }
        this.openPayMode = this.openPayMode.bind(this)
        this.handleSubmitNewCard = this.handleSubmitNewCard.bind(this)
        this.handleSubmitNewBankAccount = this.handleSubmitNewBankAccount.bind(this)
        this.refreshProposal = this.refreshProposal.bind(this)
        this.handlePaymentIntentCompleted = this.handlePaymentIntentCompleted.bind(this)
        this.buildMetaData = this.buildMetaData.bind(this)
        this.getFormattedAmount = this.getFormattedAmount.bind(this)
        this.buildIdenitifierList = this.buildIdenitifierList.bind(this)
        this.buildDocumentIds = this.buildDocumentIds.bind(this)
        this.buildAmountsList = this.buildAmountsList.bind(this)

        this.handleProposalRefresh = this.handleProposalRefresh.bind(this)
        this.handleProposalTotalRefresh = this.handleProposalTotalRefresh.bind(this)
        EventBus.listen(EventBus.TopicProposalRefresh, 'payment-section', this.handleProposalRefresh)
        EventBus.listen(EventBus.TopicProposalTotalUpdated, 'payment-section', this.handleProposalTotalRefresh)
        EventBus.listen(EventBus.TopicPreProposalTotalUpdated, 'payment-section', () => { this.setState({ loading: true }) })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy === true,
            id: nextProps.id || '',
        })
    }

    componentDidMount() {

        this.pollForExternalCheckoutPaymentConfirmation()

        let methods = this.state.section.attributes.content.paymentMethods || [PAYMENT_TYPE.CREDIT_CARD, PAYMENT_TYPE.BANK_TRANSFER]
        if (!this.state.variables.global.bankAccountPaymentIntegrationPublicApiKey) {
            methods = methods.filter(val => val !== PAYMENT_TYPE.BANK_TRANSFER)
        }
        let defaultPaymentMethod = this.state.section.attributes.content.defaultPaymentMethod || PAYMENT_TYPE.CREDIT_CARD
        if (!methods.includes(defaultPaymentMethod)) {
            defaultPaymentMethod = methods[0]
        }

        let autoOpen = this.state.autoOpen
        let paymentInProgress = this.state.paymentInProgress
        if (this.state.variables.global.externalCheckoutIntegrationKey) {
            methods = methods.filter(val => {
                return (
                    [PAYMENT_TYPE.CREDIT_CARD, PAYMENT_TYPE.BANK_TRANSFER].includes(val) ||
                    this.state.variables.global.externalCheckoutPaymentMethods.includes(val)
                )
            })

            if (methods.length === 0 && [INTEGRATION_KEY.VEND].includes(this.state.variables.global.externalCheckoutIntegrationKey)) {
                defaultPaymentMethod = "external-checkout"
                methods = ["external-checkout"]
            } else if (!methods.includes(defaultPaymentMethod)) {
                defaultPaymentMethod = methods[0]
            }

            autoOpen = true

            if (this.state.variables.lastPayment &&
                this.state.variables.lastPayment.attributes.status === PAYMENT_STATUS.PENDING &&
                ![PAYMENT_TYPE.BANK_TRANSFER].includes(this.state.variables.lastPayment.attributes.type)) {
                paymentInProgress = true
            }

            //when it's Shopify, there's no other available payment method
            if ([INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP].includes(this.state.variables.global.externalCheckoutIntegrationKey)) {
                defaultPaymentMethod = "external-checkout"
            }
        }

        this.setState({
            partialPaymentAmount: this.getFullPaymentAmount(),
            activeTab: defaultPaymentMethod,
            paymentMethods: methods,
            autoOpen: autoOpen,
            paymentInProgress: paymentInProgress,
        })
    }

    pollForExternalCheckoutPaymentConfirmation() {
        let params = (new URL(document.location)).searchParams
        let externalPaymentSuccess = params.get("externalPaymentSuccess")
        if (externalPaymentSuccess === 'true') {
            this.setState({
                loading: true,
            }, () => {
                let refreshProposal = setInterval(() => {
                    this.refreshProposal()
                    if (this.state.variables.lastPayment && !this.state.variables.lastPayment.attributes.isPendingExternalCheckout) {
                        clearInterval(refreshProposal)
                        this.setState({
                            loading: false,
                        })
                    }
                }, 1000)
            })
            return
        }
    }

    handleProposalRefresh(event) {
        if (event.getData().variables &&
            event.getData().variables.lastPayment &&
            event.getData().variables.lastPayment.attributes.status !== 'pending') {
            this.setState({
                variables: event.getData().variables,
                paymentInProgress: false,
            })
        }
    }

    handleProposalTotalRefresh(event) {
        this.setState({
            loading: false,
        })

        if (this.state.variables.global.fullPaymentAndCheckoutOnly || this.state.hideAcceptButton) {
            this.setState({
                variables: event.getData().variables,
            }, () => {
                this.state.onVariablesUpdate(this.state.variables)
                this.setState({
                    partialPaymentAmount: this.getFullPaymentAmount(),
                })
            })
        }
    }

    openPayMode(e) {
        e.preventDefault()
        this.setState({
            payMode: true
        })
    }

    getTransactions() {
        const isPartialPayment = this.state.section.attributes.content.allowPartialPayment && this.state.showEditPaymentAmount
        const amount = isPartialPayment ? this.state.partialPaymentAmount : this.getFullPaymentAmount()
        if (this.state.variables.document.type === 'account-statement') {
            const invoicesToPay = this.state.variables.customer.currentCustomerAccountTransactions
                .filter(t => t._type === 'invoices')
                .filter(t => t.balance > 0)

            let transactions = []
            let remainingAmount = amount
            for (const trans of invoicesToPay) {
                const amountToPay = NumberHelper.keep2(trans.balance)
                const transAmount = amountToPay < remainingAmount ? amountToPay : remainingAmount
                transactions.push({
                    identifier: trans.identifier,
                    amount: String(transAmount),
                    invoiceId: trans.id,
                })

                remainingAmount -= transAmount
                if (remainingAmount <= 0) {
                    break
                }
            }
            return transactions
        }

        const transaction = { amount: String(amount) }
        if (this.state.variables.document.type === 'invoice') {
            transaction.invoiceId = this.state.variables.quote.id
        }
        if (this.state.variables.document.type === 'quote') {
            transaction.quoteId = this.state.variables.quote.id
        }
        if (this.state.variables.document.type === 'order') {
            transaction.orderId = this.state.variables.quote.id
        }
        return [transaction]
    }

    getFormattedAmount() {
        return this.state.showEditPaymentAmount && this.state.partialPaymentAmount != String(this.getFullPaymentAmount()) ?
            parseFloat(this.state.partialPaymentAmount).toFixed(2).toString() :
            parseFloat(this.getFullPaymentAmount()).toFixed(2).toString()
    }


    buildIdenitifierList() {
        const identifiers = this.getTransactions().map((transaction) => {
            return transaction.identifier
        }).join(', ')
        return identifiers
    }

    buildDocumentIds() {
        const documentIds = this.getTransactions().map((transaction) => {
            return transaction.invoiceId || transaction.quoteId || transaction.orderId
        }).join(', ');
        return documentIds
    }

    buildAmountsList() {
        const amounts = this.getTransactions().map((transaction) => {
            return transaction.amount
        }).join(', ')
        return amounts
    }

    buildAccountStatementTransactionsMetadata(statementPaymentAmount, accountStatementInvoices) {
        let accountStatementTransactions = []
        let remainingPaymentAmount = parseFloat(statementPaymentAmount)
        for (let inv of accountStatementInvoices) {
            if (parseFloat(inv.balance) == 0) {
                continue
            }

            remainingPaymentAmount = remainingPaymentAmount - parseFloat(inv.balance)

            if (remainingPaymentAmount < 0) {
                inv.balance = (remainingPaymentAmount + parseFloat(inv.balance)).toString()
                accountStatementTransactions.push(inv)
                break
            }

            accountStatementTransactions.push(inv)

            if (remainingPaymentAmount == 0) {
                break
            }
        }

        return accountStatementTransactions
    }

    buildMetaData() {
        const variables = this.state.variables
        let amount = this.getFormattedAmount()
        let documentId = variables.quote.id
        let identifier = variables.document.reference
        let docType = variables.document.type
        let accountId = variables.quote.accountId
        let accountStatementId = ""
        let accountStatementInvoices = []
        const isAccountStatement = this.state.variables.document.type === 'account-statement'
        if (isAccountStatement) {
            const accountStatementInvoicesBefore = variables.customer.currentCustomerAccountTransactions?.filter(d => d._type == "invoices") || []
            accountStatementInvoices = this.buildAccountStatementTransactionsMetadata(amount, accountStatementInvoicesBefore)
            amount = this.buildAmountsList()
            documentId = this.buildDocumentIds()
            identifier = this.buildIdenitifierList()
            docType = "invoice"
            accountId = this.state.section.attributes.accountId
            accountStatementId = variables.accountStatementId
        }
        const integration = GlobalHelper.getPaymentIntegrationPerLocation(variables.quote.locationId)
        let integrationConfigurationId = integration ? integration.id : ""
        if (!integrationConfigurationId && variables.global.paymentIntegrationConfigurationId) {
            integrationConfigurationId = variables.global.paymentIntegrationConfigurationId
        }

        const metadata = {
            documentType: docType,
            identifier: identifier,
            documentId: documentId,
            contactId: variables.customer.contactId,
            accountId: accountId,
            locationId: variables.quote.locationId,
            fingerprintId: GlobalHelper.getFingerprintId(),
            amount: amount,
            source: PAYMENT_SOURCE.ONLINE,
            currency: variables.global.baseCurrency, //account currency
            documentCurrency: variables.quote.currency,
            accountStatementId: accountStatementId,
            integrationConfigurationId: integrationConfigurationId,
            accountStatementInvoices: accountStatementInvoices,
        }
        return metadata
    }

    getPaymentTransactionPayloadForSubmitNewCard(token, saveCard) {
        const data = {
            note: this.props.intl.formatMessage(messages.payment_note),
            paymentType: "credit-card",
            currency: this.getCurrency(),
            contactId: this.state.variables.customer.contactId,
            source: 'online',
            transactions: this.getTransactions(),
            fingerprintId: GlobalHelper.getFingerprintId(),
            creditCard: {
                saveCard,
            },
            locationId: this.state.variables.quote.locationId
        }

        if (token && token.billingDetails) {
            data.billingDetails = token.billingDetails
        }
        if (token && token.token) {
            data.creditCard.singleUseToken = token.token
            data.creditCard.paymentFlow = 'token'
        }

        return data
    }

    handleSubmitNewCard(setupIntent, token, saveCard, error, next) {
        if (error) {
            this.setState({
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{error.message}</small>
                </div>
            })
            next()
        } else {
            const data = this.getPaymentTransactionPayloadForSubmitNewCard(token, saveCard)
            this.processPayment(data, data.creditCard.paymentFlow !== 'token', next)
        }
    }

    processPayment(data, requiresClientSidePaymentConfirmation, next) {
        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/payment-transactions', data).then(res => {
            if (res.error) {
                this.setState({
                    loading: false,
                    creditCardError: <div className={"col-12"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                })
                next()
            } else {
                this.setState({
                    loading: false,
                    tempVariables: res.attributes.variables,
                    creditCardError: '',
                    paymentInProgress: true,
                }, () => {
                    const lastPayment = res.attributes.variables.lastPayment
                    if (!lastPayment) {
                        return
                    }
                    if (lastPayment.attributes.integratedPayment.attributes.status === 'declined') {
                        this.setState({
                            loading: false,
                            creditCardError: <div className={"col-12"}>
                                <small className={"text-danger"}>{lastPayment.attributes.note}</small>
                            </div>
                        })
                        return
                    }

                    if (requiresClientSidePaymentConfirmation) {
                        EventBus.dispatch(EventBus.TopicPaymentTransactionCreated, {
                            payment: lastPayment,
                        })
                    } else {
                        this.completePayment()
                    }
                })
            }
        })
    }

    handlePaymentIntentCompleted(paymentIntent) {
        this.setState({
            loading: false,
        })
        if (!paymentIntent.error && paymentIntent.paymentIntent.status === 'succeeded') {
            this.setState({
                submitDisabled: true,
            })
            AppContext.getApiClient().post(`/proposals/${this.state.variables.hash}/payments/${this.state.tempVariables.lastPayment.id}/confirm`, {}).then(res => {
                this.setState({
                    tempVariables: res.attributes.variables,
                    submitDisabled: false,
                }, () => {
                    this.completePayment()
                })
            })
        } else {
            this.setState({
                loading: false,
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{paymentIntent.error.message}</small>
                </div>
            })
        }
    }

    completePayment() {
        this.setState({
            variables: this.state.tempVariables,
            tempVariables: null,
            payMode: false,
            autoOpen: false,
            paymentInProgress: false,
        }, () => {
            this.setState({
                partialPaymentAmount: this.getFullPaymentAmount(),
            })
            EventBus.dispatch(EventBus.TopicProposalRefresh, {
                variables: this.state.variables,
            })
        })
    }

    handleSubmitNewBankAccount(token, next) {
        const data = {
            note: this.props.intl.formatMessage(messages.payment_note),
            paymentType: "bank-transfer",
            currency: this.getCurrency(),
            contactId: this.state.variables.customer.contactId,
            source: 'online',
            transactions: this.getTransactions(),
            fingerprintId: GlobalHelper.getFingerprintId(),
            bankAccount: {
                singleUseToken: token.token,
                bankAccountId: token.bankAccountId,
                last4: token.last4,
            },
            locationId: this.state.variables.quote.locationId
        }
        this.processPayment(data, false, next)
    }

    refreshProposal() {
        AppContext.getApiClient().get('/proposals/' + this.state.variables.hash).then(res => {
            this.setState({
                variables: res.attributes.variables,
            })
            EventBus.dispatch(EventBus.TopicProposalRefresh, {
                variables: res.attributes.variables,
            })
        })
    }

    getFullPaymentAmount() {
        if (this.state.variables.lastPayment &&
            this.state.variables.lastPayment.attributes.isPending &&
            this.state.variables.lastPayment.attributes.isExternalCheckout &&
            ![INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP].includes(this.state.variables.global.externalCheckoutIntegrationKey)
        ) {
            return parseFloat(this.getLastPendingPaymentAmount())
        }

        if (this.state.variables.document.type === 'account-statement') {
            if (this.state.variables.customer) {
                const globalBalance = this.state.variables.customer.customerAccount.attributes.globalBalance
                return globalBalance < 0 ? Math.abs(globalBalance) : 0
            } else {
                return 0
            }
        }

        if (this.state.variables.global.fullPaymentAndCheckoutOnly) {
            return this.state.variables.quote.balance
        }

        return this.state.variables.quote.needDepositPayment ?
            this.state.variables.quote.depositBalance :
            this.state.variables.quote.balance
    }

    getLastPendingPaymentAmount() {
        if (!this.state.variables || !this.state.variables.lastPayment || this.state.variables.lastPayment.attributes.status !== 'pending') {
            return "0"
        }
        return this.state.variables.lastPayment.attributes.amount
    }

    getCurrency() {
        if (this.state.variables.document.type === 'account-statement') {
            return this.state.variables.customer.customerAccount.attributes.owingBalanceCurrency
        }
        return this.state.variables.quote.currency
    }

    getPastPayments() {
        if (this.state.variables.document.type === 'account-statement' && this.state.variables.accountStatementLastTransaction) {
            return [this.state.variables.accountStatementLastTransaction]
        }

        const payments = this.state.variables.quote.payments
        return payments?.length > 0 ? this.state.variables.quote.receivedPayments : []
    }

    showPaymentFields() {
        if (!this.state.hideAcceptButton && !this.state.paymentInProgress && !this.state.isDummy &&
            !this.state.variables.global.paymentIntegrationPublicApiKey &&
            !this.state.variables.global.externalCheckoutIntegrationKey
        ) {
            return false
        }

        //dont currently support payments on proposal of type contract
        if (this.state.variables.document.type === PROPOSAL_TYPE.CONTRACT) {
            return false
        }

        return (
            this.state.hideAcceptButton ||
            this.state.paymentInProgress ||
            (["pre-approved", "approved", "sent", "partially-paid", "draft"].includes(this.state.variables.quote.status) ||
                this.state.variables.document.type === 'account-statement' ||
                (this.state.variables.document.type === 'order' && this.state.variables.quote.status !== 'draft') ||
                this.state.isDummy ||
                (["proposed"].includes(this.state.variables.quote.status) && this.state.variables.global.fullPaymentAndCheckoutOnly)
            ) &&
            !this.state.section.attributes.content.hide &&
            (this.state.variables.document.type !== 'account-statement' ? this.state.variables.quote.totalAmount > 0 : true) &&
            this.getFullPaymentAmount() > 0)

    }

    openTab(tab) {
        return function (e) {
            e.preventDefault()
            this.setState({
                activeTab: tab
            })
        }.bind(this)
    }

    renderPaymentTabs() {
        return (
            this.state.paymentMethods.length > 1 &&
            <nav className={'col-12 mt-2 px-0'}>
                <div className="nav nav-tabs justify-content-end" role="tablist">
                    {
                        this.state.paymentMethods.map(paymentMethod => {
                            return <a href="#"
                                className={`nav-item nav-link ${this.state.activeTab === paymentMethod && 'active'}`}
                                onClick={this.openTab(paymentMethod)}>
                                {ExternalPaymentTypesMapping[paymentMethod]}
                            </a>
                        })
                    }
                </div>
            </nav>
        )
    }

    renderOnlinePaymentSection(paymentAmount) {
        const submitButtonStyle = {
            outlineColor: this.state.variables.global.buttonColor,
            backgroundColor: this.state.variables.global.buttonColor,
            borderColor: this.state.variables.global.buttonColor,
            fontSize: '1rem',
            fontWeight: 'bold',
        }

        const submitDisabled = this.state.submitDisabled ||
            this.state.variables.quote.status == "draft" ||
            this.state.isDummy ||
            (this.state.section.attributes.content.allowPartialPayment &&
                this.state.partialPaymentAmount === '')

        const externalCheckoutPaymentTypes = ['external-checkout', ...Object.keys(ExternalCheckoutPaymentTypesMapping)]
        if (externalCheckoutPaymentTypes.includes(this.state.activeTab)) {
            return <OnlinePayment
                key={this.state.activeTab}
                countryCode={GlobalHelper.getCountryCodeFromCurrency(this.getCurrency())}
                proposalHash={this.state.variables.hash}
                integrationKey={this.state.variables.global.externalCheckoutIntegrationKey}
                amount={String(paymentAmount)}
                currency={this.getCurrency()}
                paymentType={'external-checkout'}
                externalCheckoutPaymentType={this.state.activeTab}
                submitButton={<FormattedMessage
                    id="payment.confirm_proceed_to_checkout_btn"
                    defaultMessage="Proceed to checkout"
                />}
                submitButtonStyle={submitButtonStyle}
                submitDisabled={submitDisabled}
                contactId={this.state.variables.customer.contactId}
                variables={this.state.variables}
            />
        }
        switch (this.state.activeTab) {
            case 'credit-card':
                return <>
                    <TestModeAlert className="mt-2" isAccountPaymentGatewayTestMode={this.state.variables.global.paymentGatewayTestMode} />
                    <OnlinePayment
                        key={this.state.activeTab}
                        countryCode={GlobalHelper.getCountryCodeFromCurrency(this.getCurrency())}
                        proposalHash={this.state.variables.hash}
                        publicKey={this.state.variables.global.paymentIntegrationPublicApiKey}
                        merchantId={this.state.variables.global.paymentIntegrationMerchantId}
                        integrationKey={this.state.variables.global.paymentIntegrationKey}
                        testMode={this.state.variables.global.paymentIntegrationTestMode}
                        amount={this.state.variables.global.paymentIntegrationKey !== INTEGRATION_KEY.RAINFOREST ? String(paymentAmount) : this.getFormattedAmount()}
                        currency={this.getCurrency()}
                        onSubmit={this.handleSubmitNewCard}
                        paymentType={'credit-card'}
                        submitButton={<FormattedMessage
                            id="payment.confirm_pay_now_btn"
                            defaultMessage="Pay Now"
                        />}
                        submitButtonStyle={submitButtonStyle}
                        forceSaveCard={this.state.section.attributes.content.forceSaveCard}
                        submitDisabled={submitDisabled}
                        onPaymentIntentCompleted={this.handlePaymentIntentCompleted}
                        contactId={this.state.variables.customer.contactId}
                        buildMetaData={this.buildMetaData}
                        onClose={this.refreshProposal}
                        paymentAccount={this.state.variables.paymentAccount}
                        isIntegrationConfigurationEnabled={this.state.variables.isIntegrationConfigurationEnabled}
                        locationId={this.state.variables.quote.locationId}
                        acceptedCardBrands={this.state.acceptedCardBrands}
                    />
                </>
            case 'bank-transfer':
                return <>
                    <TestModeAlert className="mt-2" isAccountPaymentGatewayTestMode={this.state.variables.global.paymentGatewayTestMode} />
                    <OnlinePayment
                        key={this.state.activeTab}
                        countryCode={GlobalHelper.getCountryCodeFromCurrency(this.getCurrency())}
                        proposalHash={this.state.variables.hash}
                        publicKey={this.state.variables.global.bankAccountPaymentIntegrationPublicApiKey}
                        integrationKey={this.state.variables.global.bankAccountPaymentIntegrationKey}
                        testMode={this.state.variables.global.bankAccountPaymentIntegrationTestMode}
                        companyName={this.state.variables.company.name}
                        amount={this.state.variables.global.paymentIntegrationKey !== INTEGRATION_KEY.RAINFOREST ? String(paymentAmount) : this.getFormattedAmount()}
                        currency={this.getCurrency()}
                        onSubmit={this.handleSubmitNewBankAccount}
                        paymentType={'bank-transfer'}
                        submitButton={<FormattedMessage
                            id="payment.confirm_pay_now_btn"
                            defaultMessage="Pay Now"
                        />}
                        submitButtonStyle={submitButtonStyle}
                        forceSaveBankAccount={this.state.section.attributes.content.forceSaveBankAccount}
                        submitDisabled={submitDisabled}
                        contactId={this.state.variables.customer.contactId}
                        buildMetaData={this.buildMetaData}
                        paymentAccount={this.state.variables.paymentAccount}
                        isIntegrationConfigurationEnabled={this.state.variables.isIntegrationConfigurationEnabled}
                        onClose={this.refreshProposal}
                        locationId={this.state.variables.quote.locationId}
                    />
                </>
            default: return ''
        }
    }

    isRainforestBankTransferEnabled() {
        return this.state.variables.global.paymentIntegrationKey === INTEGRATION_KEY.RAINFOREST &&
            this.state.paymentMethods.includes("bank-transfer") &&
            this.state.variables.global.hasIntegratedPayment &&
            this.state.variables.global.hasIntegratedPaymentBankAccount
    }

    render() {

        if (!this.state.section) {
            return <div />
        }
        if (this.state.variables && this.state.variables.paymentSectionDisabled) {
            return <div />
        }

        let paymentAmount = this.getFullPaymentAmount()

        if ([INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP].includes(this.state.variables.global.externalCheckoutIntegrationKey) &&
            !this.state.variables.global.fullPaymentAndCheckoutOnly) {
            paymentAmount = this.state.partialPaymentAmount
        }

        if (this.state.variables.global.externalCheckoutIntegrationKey && this.state.variables.lastPayment &&
            this.state.variables.lastPayment.attributes.status === PAYMENT_STATUS.PENDING) {
            paymentAmount = this.getLastPendingPaymentAmount()
        }

        const disabled = this.state.variables.quote.status === "draft" || this.state.loading

        const depositBtnLabel = this.state.section.attributes.content.payDepositButtonText || <FormattedMessage
            id="payment.pay_deposit_btn"
            defaultMessage="Pay Deposit Now"
        />
        const balanceBtnLabel = this.state.section.attributes.content.payBalanceButtonText || <FormattedMessage
            id="payment.pay_btn"
            defaultMessage="Pay Now"
        />

        //partial payment on account statement not working very well with RF
        if (this.state.variables.global.paymentIntegrationKey === INTEGRATION_KEY.RAINFOREST &&
            this.state.variables.document.type === PROPOSAL_TYPE.ACCOUNT_STATEMENT) {
            this.state.section.attributes.content.allowPartialPayment = false
        }

        let content = this.showPaymentFields() ?
            <div className={'col-12 mb-0 text-center py-3'}>
                <button disabled={disabled} type="submit" className="btn btn-primary px-5 py-2 approve-btn" style={{
                    outlineColor: this.state.variables.global.buttonColor,
                    backgroundColor: this.state.variables.global.buttonColor,
                    borderColor: this.state.variables.global.buttonColor,
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                }} onClick={this.openPayMode}>
                    {this.state.variables.quote.needDepositPayment ? depositBtnLabel : balanceBtnLabel}
                </button>
            </div> : ''

        if (this.showPaymentFields() &&
            (this.state.payMode || this.state.autoOpen)) {
            content = <div className={'col-12 mb-0 mt-2 pt-3 border-top'}>
                <div className={'row px-3'}>
                    <div className={`col-12 mb-0 d-flex align-items-start flex-column ${this.isRainforestBankTransferEnabled() ? "col-lg-5" : "col-lg-6"}`}>
                        <div className={'w-100 ' + (this.state.section.attributes.content.allowPartialPayment ? 'my-auto d-flex justify-content-center' : 'my-auto')}>

                            {this.state.section.attributes.content.allowPartialPayment && this.state.showEditPaymentAmount &&
                                <div className="d-flex flex-column align-items-center">
                                    <h1 className={'text-center m-0'} style={{
                                        fontWeight: 600,
                                    }}>
                                        <FormattedNumber
                                            value={this.state.partialPaymentAmount}
                                            currency={this.getCurrency()}
                                            style={'currency'}
                                        />
                                    </h1>
                                    <p className={'text-center mb-2'}>
                                        <FormattedMessage
                                            id="payment.enter_amount_to_pay_label"
                                            defaultMessage="Enter the amount you want to pay"
                                        />
                                    </p>
                                    <MoneyInputForm
                                        className="w-75"
                                        currency={this.getCurrency()}
                                        name="paymentAmount"
                                        value={this.state.partialPaymentAmount}
                                        debounced={true}
                                        onChange={(newValue) => {
                                            const totalAmount = parseFloat(this.getFullPaymentAmount())
                                            if (parseFloat(newValue) > totalAmount) {
                                                newValue = totalAmount.toString()
                                            } else if (parseFloat(newValue) < 1) {
                                                newValue = '1'
                                            }
                                            else if (newValue === '-') {
                                                newValue = '1'
                                            }
                                            this.setState({ partialPaymentAmount: newValue })
                                        }}
                                        onBlur={(newValue) => {
                                            const totalAmount = parseFloat(this.getFullPaymentAmount())
                                            newValue = parseFloat(newValue.replace(/,/, '.'))
                                            if (newValue > (totalAmount - 1) && newValue !== totalAmount) {
                                                newValue = (totalAmount - 1).toString()
                                                this.setState({ partialPaymentAmount: newValue })
                                            }
                                        }}
                                        id={'paymentAmount'}
                                    />
                                    <div className="row d-flex align-items-center w-100 mb-2 mt-2">
                                        <div className="flex-grow-1"><hr /></div>
                                        <span className="ml-2 mr-2 mt-1">
                                            <strong>
                                                <FormattedMessage
                                                    id="signup.or_label"
                                                    defaultMessage="OR"
                                                />
                                            </strong>
                                        </span>
                                        <div className="flex-grow-1"><hr /></div>
                                    </div>
                                    <button className="btn btn-primary py-2 mt-2 mb-4 approve-btn" style={{
                                        outlineColor: this.state.variables.global.buttonColor,
                                        backgroundColor: this.state.variables.global.buttonColor,
                                        borderColor: this.state.variables.global.buttonColor,
                                        fontWeight: 'bold',
                                    }} onClick={() => {
                                        this.setState({
                                            showEditPaymentAmount: !this.state.showEditPaymentAmount,
                                        })
                                    }}>
                                        <FormattedMessage
                                            id="payment.pay_full_amount_btn"
                                            defaultMessage="Pay the full amount"
                                        />
                                    </button>
                                </div>
                            }

                            {
                                !this.state.showEditPaymentAmount &&
                                <div className="d-flex flex-column align-items-center">
                                    <h1 className={'text-center m-0'} style={{
                                        fontWeight: 600,
                                    }}>
                                        <FormattedNumber
                                            value={paymentAmount}
                                            currency={this.getCurrency()}
                                            style={'currency'}
                                        />
                                    </h1>
                                    <p className={'text-center mb-1'}>
                                        {this.state.variables.quote.needDepositPayment ? <FormattedMessage
                                            id="payment.amount_due_label"
                                            defaultMessage="Amount Due"
                                        /> : <FormattedMessage
                                            id="payment.balance_due_label"
                                            defaultMessage="Balance Due"
                                        />} ({this.getCurrency()})
                                    </p>
                                    {this.state.variables.global.fullPaymentAndCheckoutOnly &&
                                        !this.state.section.attributes.content.hideAdditionalFeesMayApplyMessage &&
                                        <p className={'text-center mb-1'}>
                                            <small>
                                                <FormattedMessage
                                                    id="payment.tax_and_shipping_may_apply_label"
                                                    defaultMessage="* Tax and shipping may apply"
                                                />
                                            </small>
                                        </p>
                                    }
                                    {this.state.section.attributes.content.allowPartialPayment && !this.state.variables.global.fullPaymentAndCheckoutOnly &&
                                        <>
                                            <div className="row d-flex align-items-center w-100 mb-2 mt-2">
                                                <div className="flex-grow-1"><hr /></div>
                                                <span className="ml-2 mr-2 mt-1">
                                                    <strong>
                                                        <FormattedMessage
                                                            id="signup.or_label"
                                                            defaultMessage="OR"
                                                        />
                                                    </strong>
                                                </span>
                                                <div className="flex-grow-1"><hr /></div>
                                            </div>

                                            <button className="btn btn-primary py-2 mt-2 mb-4 approve-btn" style={{
                                                outlineColor: this.state.variables.global.buttonColor,
                                                backgroundColor: this.state.variables.global.buttonColor,
                                                borderColor: this.state.variables.global.buttonColor,
                                                fontWeight: 'bold',
                                            }} onClick={() => {
                                                this.setState({
                                                    showEditPaymentAmount: !this.state.showEditPaymentAmount,
                                                })
                                            }}>
                                                <FormattedMessage
                                                    id="payment.pay_change_amount_btn"
                                                    defaultMessage="Change amount to pay"
                                                />
                                            </button>
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    <div className={`mb-0 px-0 ${this.isRainforestBankTransferEnabled() ? "col-lg-7" : "col-lg-6"}`}>
                        {
                            this.renderPaymentTabs()
                        }
                        {
                            <div className="col-12 pt-2 bg-light border py-2 pl-4">
                                {this.renderOnlinePaymentSection(paymentAmount)}
                            </div>
                        }
                        {this.state.creditCardError}
                    </div>
                </div>
            </div>
        }

        if (this.state.loading) {
            content = <div className={'col-12 mb-0'}>
                <LoadingSpinner />
            </div>
        }

        if (['fully-paid', 'voided', 'pending'].includes(this.state.variables.quote.status)) {
            content = <div className={'col-12 mb-0'}>
                <h3 className={'py-3 text-center'}>
                    <InvoiceStatusBadge status={this.state.variables.quote.status} />
                </h3>
            </div>
        }

        if (
            ['quote', 'order'].includes(this.state.variables.document.type) &&
            !this.state.variables.quote.needDepositPayment &&
            (!this.state.paymentInProgress || !this.state.variables.global.externalCheckoutIntegrationKey)
        ) {
            content = <div className={'col-12 mb-0'} />
        }
        if (this.state.isPdf) {
            content = <div className={'col-12 mb-0'} />
        }
        if (this.state.variables.document.type === 'account-statement' && parseFloat(paymentAmount) == 0) {
            content = <div className={'col-12 mb-0'} />
        }

        const payments = this.getPastPayments().reverse()
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                included={this.state.included}
            >
                {content}
                <OnlinePaymentReceiptSection
                    variables={this.state.variables}
                    payments={payments}
                />
            </SectionWrapper>
        );
    }
}

export default injectIntl(PaymentContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/payment/section.component.jsx